export default "__VITE_ASSET__306cf6ed__"